export default function Icon1() {
    return (
        <svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="45" cy="45" r="43.65" stroke="black" strokeWidth="2.7" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M45.0786 39.082H57.1507C58.1033 39.082 58.8756 39.8967 58.8756 40.9017C58.8756 41.2338 58.7894 41.5596 58.6265 41.8437L41.3644 71.9451C40.9124 72.7334 39.9403 72.9858 39.1931 72.5089C38.6249 72.1462 38.332 71.4476 38.4601 70.7601L42.1491 50.9514H30.0755C29.1228 50.9514 28.3506 50.1367 28.3506 49.1317C28.3506 48.7999 28.4366 48.4744 28.5993 48.1904L45.8642 18.0555C46.3159 17.267 47.2879 17.0142 48.0353 17.4908C48.6037 17.8532 48.8968 18.5519 48.769 19.2395L45.0786 39.082Z"
                stroke="black"
                strokeWidth="2.7"
                strokeLinejoin="round"
            />
        </svg>
    );
}
